/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { WizardDTO, WizardStepDTO } from '@api/models/';
import { DtoManager } from '../generic';

export class Wizard extends DtoManager<WizardDTO> {
  private code: string;

  constructor(dto: WizardDTO, code: string) {
    super(dto);
    this.code = code;

    this.adjustStepsAndCode();
  }

  /**
   * stabilisce se lo step è considerabile per la UI
   */
  static isUserStep(step: WizardStepDTO): boolean {
    return step && Number(step.status) !== 4;
  }

  checkIntegrity(): void {
    if (!this.data || !this.data.wizardCode) {
      throw new Error(`Wizard data is malformed`);
    }
  }

  /**
   * aggiusta i dati del wizard aggiunge il primo step
   * prendendo i dati del wizard e impostando il wizard code reale
   */
  private adjustStepsAndCode(): void {
    this.data.steps.unshift(this.extractFirstStep());

    this.data.steps = this.data.steps
      .map(step => ({
        ...step,
        status: Number(step.status)
      }))
      .filter(step => Wizard.isUserStep(step));

    this.data.wizardCode = this.code;
  }

  /**
   * estrae il primo step dal corpo del wizard
   */
  private extractFirstStep(): WizardStepDTO {
    return {
      stepCode: this.data.wizardCode,
      parentStepCode: null,
      groupCod: this.data.groupCod || null,
      status: this.data.status
    };
  }
}
